export const FirebaseConfig = {
	"projectId": "trood-c1784",
	"appId": "1:537092971523:web:452cd7088647be961b0236",
	"databaseURL": "https://trood-c1784-default-rtdb.firebaseio.com",
	"storageBucket": "trood-c1784.appspot.com",
	"locationId": "us-central",
	"apiKey": "AIzaSyCKDXN6DBCcR_aKuwcxFF2dNb8UuyIHxec",
	"authDomain": "trood-c1784.firebaseapp.com",
	"messagingSenderId": "537092971523",
	"measurementId": "G-95ZD0FDV36"
};